import { call, put, select, takeLatest } from 'typed-redux-saga'
import { errorHandler, loadersSlice, notifyMessageCreator } from 'Modules'
import { Deserialize } from 'cerialize'
import { routerActions } from 'connected-react-router'
import { FrontUrls } from 'Src/constants/FrontUrls'
import { ResponseCatalog } from 'Models'
import { ProjectModel, projectApi, projectSlice, projectNS, projectSelector } from 'Pages/knowledge'

export function* getAllProjectSaga(action: projectNS.getAllProject) {
	try {
		if (action.payload?.params?.page === 1) {
			yield* put(loadersSlice.actions.showGlobalLoader())
		}
		const res = yield* call(projectApi.getAllProjectApi, action.payload?.params)
		const projects = Deserialize(res, ResponseCatalog)
		projects.entries = res.entries.map(
			(project): ProjectModel => Deserialize(project, ProjectModel)
		)

		if (projects.current_page > 1) {
			const previousProjects = yield* select(projectSelector.getAllProject)
			projects.entries = [...previousProjects.entries, ...projects.entries]
		}
		yield* put(projectSlice.actions.setAllProject(projects))
		if (action.payload?.params?.page === 1) {
			yield* put(loadersSlice.actions.hideGlobalLoader())
		}

		if (action?.payload?.callback) {
			action?.payload?.callback()
		}
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)

		if (action?.payload?.errorCallback) {
			action?.payload?.errorCallback()
		}
	}
}

export function* createOneProjectSaga(action: projectNS.createOneProject) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(projectApi.createOneProjectApi, action.payload)
		yield* put(projectSlice.actions.setOneProject(res))
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(notifyMessageCreator, 'knowledge.project_create.success', { data: [res.name] })
		yield* put(routerActions.push(FrontUrls.knowledge.project_edit.replace(':id', String(res.id))))
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export function* updateOneProjectSaga(action: projectNS.updateOneProject) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { id, data, callback } = action.payload
		const res = yield* call(projectApi.updateOneProjectApi, data, id)
		yield* put(projectSlice.actions.setOneProject(res))
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(notifyMessageCreator, 'knowledge.project_update.success', { data: [res.name] })
		callback?.()
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export function* deleteOneProjectSaga(action: projectNS.deleteOneProject) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(projectApi.deleteOneProjectApi, action.payload)
		yield* put(projectSlice.actions.setOneProject(null))
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(notifyMessageCreator, 'knowledge.project_delete.success')
		yield* put(routerActions.push(FrontUrls.knowledge.index))
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export function* recoverOneProjectSaga(action: projectNS.recoverOneProject) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { callback, info } = action.payload
		yield* call(projectApi.recoverOneProjectApi, info)
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(notifyMessageCreator, 'knowledge.project_restore.success')
		callback?.()
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export function* getOneProjectSaga(action: projectNS.getOneProject) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(projectApi.getOneProjectApi, action.payload)
		yield* put(projectSlice.actions.setOneProject(res))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export function* projectSaga() {
	yield* takeLatest(projectSlice.actions.getAllProject.type, getAllProjectSaga)
	yield* takeLatest(projectSlice.actions.createOneProject.type, createOneProjectSaga)
	yield* takeLatest(projectSlice.actions.updateOneProject.type, updateOneProjectSaga)
	yield* takeLatest(projectSlice.actions.deleteOneProject.type, deleteOneProjectSaga)
	yield* takeLatest(projectSlice.actions.recoverOneProject.type, recoverOneProjectSaga)
	yield* takeLatest(projectSlice.actions.getOneProject.type, getOneProjectSaga)
}
